export function closestParentElement(selector, base = this):HTMLElement {
    function __closestFrom(el) {
        if (!el || el === document || el === window) return null;
        const found = el.closest(selector);
        return found ? found : __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
